import { render, staticRenderFns } from "./Cierre.vue?vue&type=template&id=5ab4f10f&scoped=true"
import script from "./Cierre.vue?vue&type=script&lang=js"
export * from "./Cierre.vue?vue&type=script&lang=js"
import style0 from "./Cierre.vue?vue&type=style&index=0&id=5ab4f10f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab4f10f",
  null
  
)

export default component.exports